import React from 'react';

const Connect = () => {
  // Function to handle the contact action based on device type
  const handleContact = () => {
    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobileDevice) {
      // Initiate a phone call
      window.location.href = 'tel:+91 9090007108';
    } else {
      // Open WhatsApp with predefined message
      window.location.href = 'https://wa.me/919090007108?text=Hello%20there!';
    }
  };

  return (
    <div className="w-full px-4  bg-gradient-to-r from-gray-50 to-gray-100">
      <h1 className="text-3xl sm:text-5xl font-semibold text-center text-gray-800 py-8 sm:py-12">Connect With Us</h1>
      <div className="flex flex-col sm:flex-row justify-evenly items-center space-y-6 sm:space-y-0">
        {/* Call Us Button */}
        <button 
          onClick={handleContact} 
          className="bg-blue-950 text-white text-lg sm:text-3xl w-full sm:w-1/4 h-12 sm:h-16 rounded-2xl hover:scale-105 transition-transform duration-300 flex items-center justify-center shadow-lg"
        >
          Call Us
        </button>

        {/* Chat With Us Button */}
        <a 
          href="https://wa.me/919090007108?text=Hello%20there!" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="bg-blue-950 text-white text-lg sm:text-3xl w-full sm:w-1/4 h-12 sm:h-16 rounded-2xl hover:scale-105 transition-transform duration-300 flex items-center justify-center shadow-lg"
        >
          Chat With Us
        </a>
      </div>
    </div>
  );
};

export default Connect;
